import { render, staticRenderFns } from "./editOrderGroup.vue?vue&type=template&id=173358fa&scoped=true&lang=pug&"
import script from "./editOrderGroup.vue?vue&type=script&lang=js&"
export * from "./editOrderGroup.vue?vue&type=script&lang=js&"
import style0 from "./editOrderGroup.vue?vue&type=style&index=0&id=173358fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173358fa",
  null
  
)

export default component.exports